import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaProperty } from "../Schema";
import { NotEmptyString, NumberGreaterThanZero } from "../../../../Validation/Validation";
import { EntityNames } from "../../../../enums/EntityNames";

export const AccountOrderNumbersSchema: ISchema = {
    displayName: "Order Number",
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'number',
            displayName: 'Number',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function,
            validationError: "Number must be provided",
            className: "small-12"
        } as ISchemaProperty,
        {
            name: 'typeName',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            className: "small-12"
        } as ISchemaProperty,
        {
            name: 'orderNumberTypeId',
            displayName: 'Type',
            type: PropertyTypes.selectByEntityName,
            entityName: EntityNames.orderNumberTypes,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
        } as ISchemaProperty,
        {
            name: 'value',
            displayName: 'Value (£)',
            type: PropertyTypes.number,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
            validateRule: NumberGreaterThanZero as Function,
            validationError: "Value must be greater than zero",
        } as ISchemaProperty,
        {
            name: 'starts',
            displayName: 'Starts',
            type: PropertyTypes.dateOnly,
            key: false,
            showInList: true,
            showInForm: true,
            requiredInForm: true,
            className: "small-6"
        } as ISchemaProperty,
        {
            name: 'ends',
            displayName: 'Ends',
            type: PropertyTypes.dateOnly,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-6"
        } as ISchemaProperty,
    ],
}


